import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  getHostCallhistory,
  getHostGifthistory,
  getHostLivehistory,
} from "../store/history/history.action";
import dayjs from "dayjs";
import useTranslation from "../hooks/useTranslation";
import male from "../assets/images/male.png";
import rCoin from "../assets/images/shell.png";
import coinsIconImg from "../assets/images/coins.png";
import calendarIconImg from "../assets/images/calendar.png";
import calendarIcon from "../assets/images/fill-calender.png";
import phoneIconImg from "../assets/images/phone.png";
import { T, pageHeader, headerTitle, headerDesc, glassCard } from "../util/theme";

const HostHistory = () => {
  const { t } = useTranslation();
  const { hostHitory } = useSelector((state) => state?.history);
  const dispatch = useDispatch();
  const location = useLocation();
  const [activePage, setActivePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [type, setType] = useState("gift");
  const [startDate, setStartDate] = useState(
    dayjs().startOf("month").format("YYYY-MM-DD"),
  );
  const [endDate, setEndDate] = useState(
    dayjs().endOf("month").format("YYYY-MM-DD"),
  );
  const [dateModalOpen, setDateModalOpen] = useState(false);
  const [draftStart, setDraftStart] = useState(
    dayjs().startOf("month").format("YYYY-MM-DD"),
  );
  const [draftEnd, setDraftEnd] = useState(
    dayjs().endOf("month").format("YYYY-MM-DD"),
  );

  const hostId = location?.state?.id || location?.state;

  const fetchHistory = (start, end) => {
    if (type === "live") {
      dispatch(getHostLivehistory(hostId, start, end));
    } else if (type === "call") {
      dispatch(getHostCallhistory(hostId, start, end));
    } else {
      dispatch(
        getHostGifthistory(hostId, type, activePage, rowsPerPage, start, end),
      );
    }
  };

  useEffect(() => {
    const start = dayjs().startOf("month").format("YYYY-MM-DD");
    const end = dayjs().endOf("month").format("YYYY-MM-DD");
    fetchHistory(start, end);
  }, [hostId, type, activePage, rowsPerPage]);

  const openDateModal = () => {
    setDraftStart(
      dayjs(startDate).isValid()
        ? dayjs(startDate).format("YYYY-MM-DD")
        : dayjs().startOf("month").format("YYYY-MM-DD"),
    );
    setDraftEnd(
      dayjs(endDate).isValid()
        ? dayjs(endDate).format("YYYY-MM-DD")
        : dayjs().endOf("month").format("YYYY-MM-DD"),
    );
    setDateModalOpen(true);
  };

  const closeDateModal = () => setDateModalOpen(false);

  const handleApplyFilter = () => {
    const start = draftStart
      ? dayjs(draftStart).format("YYYY-MM-DD")
      : dayjs().startOf("month").format("YYYY-MM-DD");
    const end = draftEnd
      ? dayjs(draftEnd).format("YYYY-MM-DD")
      : dayjs().endOf("month").format("YYYY-MM-DD");

    setStartDate(start);
    setEndDate(end);
    fetchHistory(start, end);
    setDateModalOpen(false);
  };

  const tabs = [
    { id: "gift", label: t("gift") },
    { id: "call", label: t("call") },
    { id: "live", label: t("live") },
  ];

  const EmptyBlock = ({ title, subtitle }) => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "55vh",
        textAlign: "center",
        color: T.sub,
        border: "none",
        background: "transparent",
        padding: "24px 16px",
      }}
    >
      <div
        style={{
          color: "#fff",
          fontSize: 18,
          fontWeight: 600,
          marginBottom: 8,
        }}
      >
        {title}
      </div>
      <div style={{ fontSize: 14, fontWeight: 400 }}>{subtitle}</div>
    </div>
  );

  const DetailRow = ({ icon, label, value }) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
      }}
    >
      <div
        style={{
          width: 36,
          height: 36,
          borderRadius: 10,
          background: T.iconBox,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          color: "#fff",
          lineHeight: 0,
        }}
      >
        {icon}
      </div>
      <span style={{ color: T.sub, fontSize: 14, fontWeight: 400, flex: 1 }}>
        {label}
      </span>
      <span style={{ color: "#fff", fontWeight: 700, fontSize: 14 }}>{value}</span>
    </div>
  );

  const HistoryCard = ({
    name,
    id,
    image,
    middleLabel,
    middleValue,
    middleIcon,
    date,
    showShell = true,
  }) => (
    <div
      style={{
        ...glassCard,
        padding: 16,
        marginBottom: 12,
      }}
    >
      {/* Header: avatar + name | ID */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
        }}
      >
        <img
          src={image || male}
          alt=""
          onError={(e) => {
            e.target.src = male;
          }}
          style={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            objectFit: "cover",
            flexShrink: 0,
          }}
        />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              color: "#fff",
              fontWeight: 700,
              fontSize: 15,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {name || "-"}
          </div>
        </div>
        {id != null && id !== "" && (
          <div style={{ color: T.sub, fontSize: 13, fontWeight: 400, flexShrink: 0 }}>
            ID: {id}
          </div>
        )}
      </div>

      <div style={{ height: 1, background: T.border, margin: "14px 0 12px" }} />

      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        <DetailRow
          icon={middleIcon}
          label={middleLabel}
          value={
            <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
              {showShell && <img src={rCoin} alt="" width={20} height={18} />}
              {middleValue}
            </span>
          }
        />
        <DetailRow
          icon={
            <img
              src={calendarIcon}
              alt=""
              width={18}
              height={18}
              style={{ objectFit: "contain", display: "block" }}
            />
          }
          label={t("date")}
          value={date || "-"}
        />
      </div>
    </div>
  );

  return (
    <>
      <div
        className="page"
        style={{
          background: "transparent",
          minHeight: "100vh",
          paddingBottom: 16,
        }}
      >
        <div style={{ ...pageHeader, maxWidth: 480, margin: "0 auto", width: "100%", boxSizing: "border-box" }}>
          <div style={{fontWeight: 700, fontSize: 20, color: "#FFFFFF", lineHeight: 1}}>{t("host_history")}</div>
          <div style={{fontWeight: 400, fontSize: 14, color: "#FFFFFF80", marginTop: 5, lineHeight: "17px"}}>{t("host_earning")}</div>
        </div>

        <div className="main-wrapper">
          <div className="main-section" style={{ padding: "12px 16px", maxWidth: 480, margin: "0 auto" }}>
            {/* Tabs + calendar on right — matches uploaded image */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: 18,
              }}
            >
              <div style={{ display: "flex", flex: 1, gap: 8 }}>
                {tabs.map((tab) => {
                  const active = type === tab.id;
                  return (
                    <button
                      key={tab.id}
                      type="button"
                      className={`agency-tab-pill${active ? " active" : ""}`}
                      onClick={() => setType(tab.id)}
                      style={{
                        padding: "8px 20px",
                        fontWeight: 500,
                        fontSize: 13,
                        color: "#FFFFFFC2",
                        lineHeight: "100%",
                        cursor: "pointer",
                        minHeight: 22,
                      }}
                    >
                      {tab.label}
                    </button>
                  );
                })}
              </div>

              <button
                type="button"
                onClick={openDateModal}
                style={{
                  background: "transparent",
                  border: "none",
                  width: 36,
                  height: 36,
                  display: "grid",
                  placeItems: "center",
                  cursor: "pointer",
                  color: "#fff",
                  flexShrink: 0,
                  padding: 0,
                }}
                title={
                  dayjs(startDate).isValid() && dayjs(endDate).isValid()
                    ? `${dayjs(startDate).format("DD/MM/YYYY")} - ${dayjs(
                        endDate,
                      ).format("DD/MM/YYYY")}`
                    : "Select Date Range"
                }
              >
                <img
                  src={calendarIconImg}
                  alt=""
                  width={24}
                  height={24}
                  style={{ objectFit: "contain", display: "block" }}
                />
              </button>
            </div>

            {dateModalOpen && (
              <DateRangeModal
                draftStart={draftStart}
                draftEnd={draftEnd}
                setDraftStart={setDraftStart}
                setDraftEnd={setDraftEnd}
                onCancel={closeDateModal}
                onApply={handleApplyFilter}
                t={t}
              />
            )}

            <div className="history-content">
              {type === "gift" && (
                <div>
                  {hostHitory?.length > 0 ? (
                    hostHitory.map((data, index) => (
                      <HistoryCard
                        key={index}
                        name={data?.name}
                        id={data?.uniqueId}
                        image={data?.image || data?.user?.image}
                        middleLabel={t("coin_income")}
                        middleValue={data?.totalRCoin || 0}
                        middleIcon={
                          <img
                            src={coinsIconImg}
                            alt=""
                            width={18}
                            height={18}
                            style={{ objectFit: "contain", display: "block" }}
                          />
                        }
                        date={data?.date}
                        showShell
                      />
                    ))
                  ) : (
                    <EmptyBlock
                      title={t("no_gift_history")}
                      subtitle={t("gift_periods")}
                    />
                  )}
                </div>
              )}

              {type === "call" && (
                <div>
                  {hostHitory?.length > 0 ? (
                    hostHitory.map((data, index) => {
                      const callTime =
                        data?.duration ||
                        data?.callTime ||
                        (data?.callStartTime && data?.callEndTime
                          ? `${data.callStartTime.split(",")[1] || data.callStartTime} - ${
                              data.callEndTime.split(",")[1] || data.callEndTime || "Ongoing"
                            }`
                          : data?.callType === "MissedCall"
                            ? t("missed_call")
                            : "-");
                      return (
                        <HistoryCard
                          key={index}
                          name={data?.userName}
                          id={data?.uniqueId}
                          image={data?.image || data?.userImage || data?.user?.image}
                          middleLabel="Call Time"
                          middleValue={callTime}
                          middleIcon={
                            <img
                              src={phoneIconImg}
                              alt=""
                              width={18}
                              height={18}
                              style={{ objectFit: "contain", display: "block" }}
                            />
                          }
                          date={
                            data?.date?.split(",")[0] ||
                            data?.callStartTime?.split(",")[0]
                          }
                          showShell={false}
                        />
                      );
                    })
                  ) : (
                    <EmptyBlock
                      title={t("no_call_history")}
                      subtitle={t("call_record")}
                    />
                  )}
                </div>
              )}

              {type === "live" && (
                <div>
                  {hostHitory?.length > 0 ? (
                    hostHitory.map((data, index) => (
                      <HistoryCard
                        key={index}
                        name={data?.name || data?.userName || location?.state?.name || "-"}
                        id={data?.uniqueId || location?.state?.uniqueId}
                        image={data?.image || data?.user?.image || location?.state?.image}
                        middleLabel={t("coin_income")}
                        middleValue={data?.rCoin || 0}
                        middleIcon={
                          <img
                            src={coinsIconImg}
                            alt=""
                            width={18}
                            height={18}
                            style={{ objectFit: "contain", display: "block" }}
                          />
                        }
                        date={data?.startTime?.split(",")[0] || data?.date}
                        showShell
                      />
                    ))
                  ) : (
                    <EmptyBlock
                      title={t("no_live_history")}
                      subtitle={t("no_live_stream")}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const DateRangeModal = ({
  draftStart,
  draftEnd,
  setDraftStart,
  setDraftEnd,
  onCancel,
  onApply,
  t,
}) => {
  const inputStyle = {
    width: "100%",
    boxSizing: "border-box",
    background: "rgba(20, 10, 40, 0.85)",
    border: `1px solid ${T.border}`,
    borderRadius: 14,
    padding: "14px 16px",
    color: "#fff",
    fontSize: 15,
    fontWeight: 500,
    outline: "none",
    colorScheme: "dark",
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2000,
        background: "rgba(8, 2, 20, 0.72)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
      onClick={onCancel}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%",
          maxWidth: 360,
          background: "#1A1230",
          border: `1px solid ${T.border}`,
          borderRadius: 28,
          padding: "22px 20px 20px",
          boxShadow: "0 20px 50px rgba(0,0,0,0.45)",
        }}
      >
        {/* Header */}
        <div
          style={{
            position: "relative",
            textAlign: "center",
            marginBottom: 22,
            paddingRight: 36,
            paddingLeft: 36,
          }}
        >
          <div
            style={{
              color: "#fff",
              fontSize: 18,
              fontWeight: 700,
              lineHeight: 1.3,
            }}
          >
            {t("select_date_range", "Select Date Range")}
          </div>
          <button
            type="button"
            onClick={onCancel}
            aria-label="Close"
            style={{
              position: "absolute",
              top: -2,
              right: 0,
              width: 32,
              height: 32,
              borderRadius: "50%",
              border: "none",
              background: "rgba(255,255,255,0.08)",
              color: "#fff",
              display: "grid",
              placeItems: "center",
              cursor: "pointer",
              padding: 0,
            }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {/* Start Date */}
        <div style={{ marginBottom: 16 }}>
          <div
            style={{
              color: "#fff",
              fontSize: 14,
              fontWeight: 600,
              marginBottom: 8,
            }}
          >
            {t("start_date", "Start Date")}
          </div>
          <input
            type="date"
            value={draftStart || ""}
            max={draftEnd || dayjs().format("YYYY-MM-DD")}
            onChange={(e) => setDraftStart(e.target.value)}
            placeholder="DD/MM/YYYY"
            style={inputStyle}
          />
        </div>

        {/* End Date */}
        <div style={{ marginBottom: 22 }}>
          <div
            style={{
              color: "#fff",
              fontSize: 14,
              fontWeight: 600,
              marginBottom: 8,
            }}
          >
            {t("end_date", "End Date")}
          </div>
          <input
            type="date"
            value={draftEnd || ""}
            min={draftStart || undefined}
            max={dayjs().format("YYYY-MM-DD")}
            onChange={(e) => setDraftEnd(e.target.value)}
            placeholder="DD/MM/YYYY"
            style={inputStyle}
          />
        </div>

        {/* Actions */}
        <div style={{ display: "flex", gap: 12 }}>
          <button
            type="button"
            onClick={onCancel}
            style={{
              flex: 1,
              border: "none",
              borderRadius: 10,
              padding: "14px 12px",
              background: "rgba(70, 78, 110, 0.85)",
              color: "#fff",
              fontWeight: 700,
              fontSize: 15,
              cursor: "pointer",
            }}
          >
            {t("cancel", "Cancel")}
          </button>
          <button
            type="button"
            onClick={onApply}
            className="agency-grad-btn"
            style={{
              flex: 1,
              border: "none",
              borderRadius: 999,
              padding: "14px 12px",
              background: T.gradPinkPurple,
              color: "#fff",
              fontWeight: 700,
              fontSize: 15,
              cursor: "pointer",
              boxShadow: "0 6px 18px rgba(255,45,143,0.35)",
            }}
          >
            {t("apply_filter", "Apply Filter")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HostHistory;
